module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "facing-type-card-new"
  }, [_c('div', {
    staticClass: "facing-type-card-new__controller"
  }, [_c('button', {
    staticClass: "facing-type-card-new__controller--back-button",
    on: {
      "click": _vm.goMyCardList
    }
  }, [(_vm.targetUser === 'give') ? [_c('img', {
    staticClass: "back-button__image",
    attrs: {
      "src": require("../images/arrow_left_brown.png"),
      "alt": "渡したカード"
    }
  }), _c('span', {
    staticClass: "back-button__text"
  }, [_vm._v("渡したカード")])] : [_c('img', {
    staticClass: "back-button__image",
    attrs: {
      "src": require("../images/arrow_left_brown.png"),
      "alt": "もらったカード"
    }
  }), _c('span', {
    staticClass: "back-button__text"
  }, [_vm._v("もらったカード")])]], 2), _c('button', {
    staticClass: "facing-type-card-new__controller--register-button",
    class: {
      '-disabled': _vm.noSelectedAllRequired
    },
    attrs: {
      "disabled": _vm.noSelectedAllRequired
    },
    on: {
      "click": _vm.registFacingTypeCard
    }
  }, [_vm._v("登録する")])]), _c('div', {
    staticClass: "facing-type-card-new__controller-blank"
  }), _c('div', {
    staticClass: "facing-type-card-new__header-wrapper"
  }, [_c('div', {
    staticClass: "facing-type-card-new__header"
  }, [_c('h2', {
    staticClass: "facing-type-card-new__header--title"
  }, [(_vm.targetUser === 'give') ? [_vm._v("対面で渡すカードは")] : [_vm._v("手渡しでもらったカードは")], _c('br'), _vm._v("ここから写真を登録してニャン♪")], 2), _vm._m(0), _vm._m(1), _vm._m(2)])]), _c('div', {
    staticClass: "facing-type-card-new__main"
  }, [_c('div', [_vm._m(3), _c('div', {
    staticClass: "main__container"
  }, [_c('div', {
    staticClass: "main__container--box"
  }, [_vm._m(4), _c('p', {
    staticClass: "main__container--explanation"
  }, [_vm._v("メッセージが書いてある面を選択するニャン♪")]), (_vm.showErrorFrontImage) ? _c('p', {
    staticClass: "facing-type-card-new__error-message"
  }, [_vm._v("画像は .jpg .jpeg .png形式でお願いします")]) : _vm._e(), (_vm.selectedFrontImage) ? _c('div', {
    staticClass: "main__container--selected-image"
  }, [_c('button', {
    staticClass: "selected-image__close-button",
    on: {
      "click": _vm.closeFrontImage
    }
  }), _c('img', {
    attrs: {
      "src": _vm.selectedFrontImage
    }
  })]) : _vm._e(), _c('button', {
    staticClass: "main__container--flex-button",
    on: {
      "click": function($event) {
        _vm.$refs.frontImageInputRef.click()
      }
    }
  }, [_vm._m(5), _vm._v("画像を選ぶ")]), _c('input', {
    ref: "frontImageInputRef",
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "type": "file"
    },
    on: {
      "change": function($event) {
        $event.preventDefault();
        return _vm.selectFrontImage($event)
      }
    }
  })]), _c('div', [_vm._m(6), (_vm.showErrorBackImage) ? _c('p', {
    staticClass: "facing-type-card-new__error-message"
  }, [_vm._v("画像は .jpg .jpeg .png形式でお願いします")]) : _vm._e(), (_vm.selectedBackImage) ? _c('div', {
    staticClass: "main__container--selected-image"
  }, [_c('button', {
    staticClass: "selected-image__close-button",
    on: {
      "click": _vm.closeBackImage
    }
  }), _c('img', {
    attrs: {
      "src": _vm.selectedBackImage
    }
  })]) : _vm._e(), _c('button', {
    staticClass: "main__container--flex-button",
    on: {
      "click": function($event) {
        _vm.$refs.backImageInputRef.click()
      }
    }
  }, [_vm._m(7), _vm._v("画像を選ぶ")]), _c('input', {
    ref: "backImageInputRef",
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "type": "file"
    },
    on: {
      "change": function($event) {
        $event.preventDefault();
        return _vm.selectBackImage($event)
      }
    }
  })])])]), _c('div', [_c('h2', {
    staticClass: "main__band"
  }, [_c('span', {
    staticClass: "main__band--number"
  }, [_vm._v("2")]), (_vm.targetUser === 'give') ? [_vm._v("誰に渡すニャン？")] : [_vm._v("誰からもらったニャン？")], _c('span', {
    staticClass: "main__band--required"
  }, [_vm._v("(必須)")])], 2), _c('div', {
    staticClass: "main__container"
  }, [_c('button', {
    on: {
      "click": function($event) {
        _vm.showUserSelectModal = true
      }
    }
  }, [_c('div', {
    staticClass: "main__container--grid-button"
  }, [(_vm.selectedUser.id) ? [_c('div', {
    staticClass: "grid-button__user-image"
  }, [_c('img', {
    staticClass: "grid-button__user-image--crop",
    attrs: {
      "src": _vm.getUserImage
    }
  })]), _c('div', {
    staticClass: "grid-button__user-info"
  }, [_c('div', [_c('div', {
    staticClass: "grid-button__user-info--shop-name"
  }, [_vm._v(_vm._s(_vm.selectedUser.attributes['shop-name']) + " " + _vm._s(_vm.selectedUser.attributes['user-type-name']))]), _c('div', {
    staticClass: "grid-button__user-info--name"
  }, [_vm._v(_vm._s(_vm.selectedUser.attributes['user-name']) + " " + _vm._s(_vm.selectedUser.attributes['user-firstname']))])])])] : [_vm._m(8), _c('div', {
    staticClass: "grid-button__name"
  }, [_vm._v("選択する")]), _vm._m(9)]], 2)])])]), _c('div', [_vm._m(10), _c('div', {
    staticClass: "main__container -bg-orange"
  }, [_c('div', {
    staticClass: "main__container--philosophies"
  }, [_c('p', {
    staticClass: "philosophy__target"
  }, [_vm._v("CSV")]), _c('button', {
    staticClass: "philosophy__button",
    class: {
      '-selected': _vm.csv.idea_peace_ming
    },
    on: {
      "click": function($event) {
        _vm.csv.idea_peace_ming = !_vm.csv.idea_peace_ming
      }
    }
  }, [_vm._v("安心")]), _c('button', {
    staticClass: "philosophy__button",
    class: {
      '-selected': _vm.csv.idea_sincere
    },
    on: {
      "click": function($event) {
        _vm.csv.idea_sincere = !_vm.csv.idea_sincere
      }
    }
  }, [_vm._v("誠実")]), _c('button', {
    staticClass: "philosophy__button",
    class: {
      '-selected': _vm.csv.idea_excitement
    },
    on: {
      "click": function($event) {
        _vm.csv.idea_excitement = !_vm.csv.idea_excitement
      }
    }
  }, [_vm._v("感動")]), _c('button', {
    staticClass: "philosophy__button",
    class: {
      '-selected': _vm.csv.idea_comfortable
    },
    on: {
      "click": function($event) {
        _vm.csv.idea_comfortable = !_vm.csv.idea_comfortable
      }
    }
  }, [_vm._v("快適")]), _c('button', {
    staticClass: "philosophy__button",
    class: {
      '-selected': _vm.csv.idea_creation
    },
    on: {
      "click": function($event) {
        _vm.csv.idea_creation = !_vm.csv.idea_creation
      }
    }
  }, [_vm._v("創造")])]), _c('hr', {
    staticClass: "main__container--separator"
  }), _c('div', {
    staticClass: "main__container--philosophies"
  }, [_c('p', {
    staticClass: "philosophy__target"
  }, [_vm._v("ESV")]), _c('button', {
    staticClass: "philosophy__button",
    class: {
      '-selected': _vm.esv.idea_civility
    },
    on: {
      "click": function($event) {
        _vm.esv.idea_civility = !_vm.esv.idea_civility
      }
    }
  }, [_vm._v("礼節")]), _c('button', {
    staticClass: "philosophy__button",
    class: {
      '-selected': _vm.esv.idea_imagination
    },
    on: {
      "click": function($event) {
        _vm.esv.idea_imagination = !_vm.esv.idea_imagination
      }
    }
  }, [_vm._v("想像")]), _c('button', {
    staticClass: "philosophy__button",
    class: {
      '-selected': _vm.esv.idea_sympathy
    },
    on: {
      "click": function($event) {
        _vm.esv.idea_sympathy = !_vm.esv.idea_sympathy
      }
    }
  }, [_vm._v("感応")]), _c('button', {
    staticClass: "philosophy__button",
    class: {
      '-selected': _vm.esv.idea_expression
    },
    on: {
      "click": function($event) {
        _vm.esv.idea_expression = !_vm.esv.idea_expression
      }
    }
  }, [_vm._v("表現")]), _c('button', {
    staticClass: "philosophy__button",
    class: {
      '-selected': _vm.esv.idea_challenge_dream
    },
    on: {
      "click": function($event) {
        _vm.esv.idea_challenge_dream = !_vm.esv.idea_challenge_dream
      }
    }
  }, [_vm._v("挑夢")])])])])]), (_vm.showUserSelectModal) ? _c('facing-type-card-user-select', {
    attrs: {
      "target": _vm.targetUser
    },
    on: {
      "select-user": _vm.selectUser,
      "close-modal": function($event) {
        _vm.showUserSelectModal = false
      }
    }
  }) : _vm._e(), (_vm.showCompletedRegisterModal) ? [_c('div', {
    staticClass: "facing-type-card-new__modal"
  }, [_c('div', {
    staticClass: "facing-type-card-new__modal--overlay"
  }), _c('div', {
    staticClass: "facing-type-card-new__modal--main"
  }, [_c('h2', {
    staticClass: "modal-main__title"
  }, [_vm._v("カードを登録しました")]), _vm._m(11), _c('div', {
    staticClass: "modal-main__buttons"
  }, [_c('router-link', {
    staticClass: "modal-main__buttons--normal",
    attrs: {
      "to": "/es_mycard_list"
    }
  }, [_vm._v("みんなのカード一覧へ"), _c('img', {
    staticClass: "modal-main__buttons--arrow-right",
    attrs: {
      "src": require("../images/arrow_right_blue.png")
    }
  })])], 1)])])] : _vm._e(), (_vm.showHeadsUpModal) ? [_c('div', {
    staticClass: "heads_up__modal"
  }, [_c('div', {
    staticClass: "heads_up__modal--overlay"
  }), _c('div', {
    staticClass: "heads_up__modal--main"
  }, [_vm._m(12), _vm._m(13), _c('div', {
    staticClass: "modal-main__buttons"
  }, [_c('a', {
    staticClass: "modal-main__buttons--normal",
    on: {
      "click": function($event) {
        _vm.showHeadsUpModal = false
      }
    }
  }, [_vm._v("カード登録へ"), _c('img', {
    staticClass: "modal-main__buttons--arrow-right",
    attrs: {
      "src": require("../images/arrow_right_blue.png")
    }
  })])])])])] : _vm._e(), _vm._m(14)], 2)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "facing-type-card-new__header--text"
  }, [_vm._v("（相手が既にUPしてたら、"), _c('br'), _vm._v("重複登録は不要だニャン♪）")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "facing-type-card-new__header--cartoon1"
  }, [_c('img', {
    attrs: {
      "src": require("../images/img_cat_taking_picture.png")
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "facing-type-card-new__header--cartoon2"
  }, [_c('img', {
    attrs: {
      "src": require("../images/img_cat_raise_photo.png")
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h2', {
    staticClass: "main__band"
  }, [_c('span', {
    staticClass: "main__band--number"
  }, [_vm._v("1")]), _vm._v("カードを撮影＆登録してニャン")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h3', {
    staticClass: "main__container--titile"
  }, [_vm._v("表面"), _c('span', {
    staticClass: "main__container--state -required"
  }, [_vm._v("必須")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "main__container--flex-button-image"
  }, [_c('img', {
    attrs: {
      "src": require("../images/icon_image_blue.png")
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h3', {
    staticClass: "main__container--titile"
  }, [_vm._v("裏面"), _c('span', {
    staticClass: "main__container--state -any"
  }, [_vm._v("任意")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "main__container--flex-button-image"
  }, [_c('img', {
    attrs: {
      "src": require("../images/icon_image_blue.png")
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "grid-button__user-image"
  }, [_c('img', {
    staticClass: "grid-button__user-image--crop",
    attrs: {
      "src": require("../images/icon_submenu_face.png")
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "grid-button__arrow-right"
  }, [_c('img', {
    attrs: {
      "src": require("../images/arrow_right_blue.png")
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h2', {
    staticClass: "main__band"
  }, [_c('span', {
    staticClass: "main__band--number"
  }, [_vm._v("3")]), _vm._v("該当する理念を選択してニャン♪"), _c('span', {
    staticClass: "main__band--required"
  }, [_vm._v("(必須)")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-main__cartoon"
  }, [_c('img', {
    staticClass: "modal-main__cartoon--image",
    attrs: {
      "src": require("../images/img_cat_13.png"),
      "alt": "ねこ"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h2', {
    staticClass: "modal-main__title"
  }, [_vm._v("もらった相手が笑顔になる"), _c('span', [_vm._v("内容を書くニャン♪")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-main__cartoon"
  }, [_c('img', {
    staticClass: "modal-main__cartoon--image",
    attrs: {
      "src": require("../images/img_cat_right_hand.png"),
      "alt": "ねこ"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "loading"
  }, [_c('button', {
    staticClass: "hide",
    attrs: {
      "id": "loadingModalButton",
      "type": "button",
      "data-backdrop": "static",
      "data-toggle": "modal",
      "data-target": "#loadingModal"
    }
  }, [_vm._v("モーダル発火用")]), _c('div', {
    staticClass: "help-modal",
    attrs: {
      "id": "loadingModal"
    }
  }, [_c('div', {
    staticClass: "help-modal__body bg03",
    staticStyle: {
      "margin-top": "20px",
      "margin-bottom": "20px"
    }
  }, [_c('h4', {
    staticClass: "heading_01 mb25"
  }, [_vm._v("投稿中だニャン♪")]), _c('div', {
    staticClass: "box_01 help-modal__body__txt -login-done"
  }, [_c('p', [_vm._v("暫くそのまま"), _c('br'), _vm._v("お待ちくださいだニャン！")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-5aea5b4f!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./src/components/templates/facingtype-card-new.pug
// module id = 1399
// module chunks = 1